export { default as Profile } from "./main";

import * as Anchors from "./anchors";
import { default as routes } from "./routes";

export const profile$ = {
  Anchors,
  routes,
};
